import _classCallCheck from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import { EvRepositoryApi } from "./EvRepositoryApi";
var repoApi = new EvRepositoryApi();
export var EvUserPreferencesApi = /*#__PURE__*/function () {
  function EvUserPreferencesApi() {
    _classCallCheck(this, EvUserPreferencesApi);
  }
  _createClass(EvUserPreferencesApi, [{
    key: "fetchUserPreferences",
    value: function fetchUserPreferences(body) {
      return repoApi.getCollectionResource("userPrefses");
    }
  }, {
    key: "updateUserPreferences",
    value: function updateUserPreferences(body) {
      return repoApi.patchItemResource(body, "userPrefses", body.environment + "_" + body.userid);
    }
  }, {
    key: "updateUserSession",
    value: function updateUserSession(body) {
      return repoApi.patchItemResource(body, "sessionsettings", "0");
    }
  }]);
  return EvUserPreferencesApi;
}();